import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { selectDefaultProduct } from '~/components/brand/ducks/selectors.js';
import { basePathname } from '~/utils/pathname';
import useUIContext from '~/ui/use-ui-context.ts';

const DeferredRedirect = ({ unauthPaths }) => {
	const location = useLocation();
	const defaultProduct = useSelector(selectDefaultProduct);
	const { contexts } = useUIContext();

	const currentLocationPath = typeof location === 'object' ? location.pathname : location;
	const isUnauthenticatedRoute = unauthPaths.includes(currentLocationPath);
	const pathname = isUnauthenticatedRoute ? basePathname() : basePathname(defaultProduct);
	// TODO, extended contextualPathTransformer to support state
	const { queryEncoder } = contexts.find(({ routesMatcher }) => routesMatcher(currentLocationPath));
	const newLocation = queryEncoder({
		location: {
			pathname
		},
		to: location
	});
	return <Navigate to={newLocation} />;
};

export default DeferredRedirect;
